import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Mask, Button, Dialog, Toast, Toptips } from 'react-weui'
import Clipboard from 'clipboard'
import { renderMoney } from '../../utils'
import Header from '../../components/liveroomLecturer/Header'
import { Page, WKTab } from '../../components'
import { WKSearch, WkPanel, WKVisible } from '../../components/wk'
import MediaItem from './MediaItem'
import ResellLiveroomGoods from './ResellLiveroomGoods'
import ResellLiveroomInvites from './ResellLiveroomInvites'
import '../../css/page/ResellPage.css'
import questionImg from '../../images/question.png'
import wxMomentImg from '../../images/wx-moment.png'
import wxMenuImg from '../../images/wx-menu.png'


class ResellLiveroomPage extends React.Component {
    componentDidMount () {
        document.title = '直播间分销商'
        this.props.dispatch({
            type: 'COMPONENT_INIT_WKTAB',
            payload: {
                selectId: 0,
                list: [{
                    id: 0,
                    selected: true,
                    name: '商品列表',
                }, {
                    id: 1,
                    name: '邀请列表',
                }]
            }
        })
    }
    componentWillReceiveProps (props) {
        if (props.selectId !== this.props.selectId) {
            window.scrollTo(0, 0)
        }
    }
    render() {
        return (
            <div className='wk-page resell-liveroom-page'>
                <WKTab />
                <WKVisible show={this.props.selectId == 0}>
                    <ResellLiveroomGoods {...this.props} />
                </WKVisible>
                <WKVisible show={this.props.selectId == 1}>
                    <ResellLiveroomInvites {...this.props} />
                </WKVisible>
            </div>
        )
    }
}

export default connect(state => ({
    selectId: state.component.wkTab.selectId
}))(ResellLiveroomPage)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellLiveroomPage.js